import { render, staticRenderFns } from "./FertilizationCalculation.vue?vue&type=template&id=ca7ddbe8&scoped=true&lang=html&"
import script from "./FertilizationCalculation.vue?vue&type=script&lang=js&"
export * from "./FertilizationCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7ddbe8",
  null
  
)

export default component.exports